import * as qs from 'qs';

import type { Project } from '../types';

type GetAuthorizeServiceURLProps = {
  vcsHost: Project['vcs_host'] | 'slack';
  location: string;
  serviceConnect?: boolean;
  projectLocator?: string;
  isPrivateAccess?: boolean
  instanceName?: string;
};

/**
 * Generates the "authorize service" URL for the given VCS host and project.
 * There is some nuance in encoding the window.location, which is mostly
 * why this was broken off as a helper/util.
 *
 * @param {GetAuthorizeServiceURLProps} props - The props.
 * @param {Project['vcs_host']} props.vcsHost - The VCS host.
 * @param {Location | string} props.location - Either `window.location.href`, or a similar string of the current full URL.
 * @param {boolean} [props.serviceConnect] - Whether to include the `service_connect` query params.
 * @param {string} [props.projectLocator] - The project locator. If included, `project_id` will be included in the query params.
 * @param {boolean} [props.isPrivateAccess] - Whether to include the `private_access` query params.
 * @param {string} [props.instanceName] - The instance name.
 */
export function getAuthorizeServiceURL({
  vcsHost,
  location,
  serviceConnect,
  projectLocator,
  isPrivateAccess,
  instanceName,
}: GetAuthorizeServiceURLProps): `/api/services/${GetAuthorizeServiceURLProps['vcsHost']}/authorize?${string}` {
  const query = qs.stringify({
    next: location, // Note that stringify will handle URL encoding this.
    project_id: projectLocator || undefined,
    //  Used when connecting to a service for the first time.
    service_connect: serviceConnect ? true : undefined,
    //  This one is passed as a number.
    private_access: isPrivateAccess ? 1 : undefined,
    instanceName: instanceName || undefined,
  });
  return `/api/services/${vcsHost}/authorize?${query}`;
}
